var a = /* @__PURE__ */ ((r) => (r[r.Verbose = 0] = "Verbose", r[r.Debug = 1] = "Debug", r[r.Information = 2] = "Information", r[r.Warning = 3] = "Warning", r[r.Error = 4] = "Error", r[r.Fatal = 5] = "Fatal", r))(a || {});
export {
  a as LogLevel
};
